export enum UploadStage {
  CHUNKING = "chunking",
  CATEGORIZING = "categorizing",
  TABLE_PARSING = "table-parsing",
  TABLE_PROCESSING = "table-processing",
  ROLE_ASSIGNING = "role-assigning",
  TEXT_BLOCK = "text-block",
  FINAL_STAGE = "final-stage",
  COMPLETE = "complete",
}
